import { createSlice } from '@reduxjs/toolkit';
export interface IInitState {
  userinfo: {
    head_image: string;
    id: number;
    name: string;
    nickname: string;
    username: string;
  };
  age: number;
  login_status: string;
  apiUserInfo: {
    nick_name: string;
    org_name: string;
    org_id: number;
    status: string;
    user_id: number;
    user_type: number;
    permission: string[];
    ku_reviewed: number;
    lesson: string;
    audit_batch_orgs: number[];
  };
}

const initialState: IInitState = {
  userinfo: {
    head_image: '',
    id: 0,
    name: '',
    nickname: '',
    username: '',
  },
  age: 18,
  login_status: 'logout',
  apiUserInfo: {
    nick_name: '',
    org_name: '',
    org_id: 0,
    status: 'logout',
    user_id: 0,
    user_type: -1,
    permission: [],
    ku_reviewed: 0,
    lesson: '',
    audit_batch_orgs: [],
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setuserInfo: (state, action) => {
      state.userinfo = action.payload;
    },
    setAge: (state, action) => {
      state.age = action.payload;
    },
    setLoginStatus: (state, action) => {
      state.login_status = action.payload;
    },
    setApiUserInfo: (state, action) => {
      state.apiUserInfo = action.payload;
    },
  },
});

export const { setuserInfo, setAge, setLoginStatus, setApiUserInfo } =
  userSlice.actions;
export default userSlice.reducer;
